import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import './ThemeToggle.module.css';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  const handleClick = (event) => {
    toggleTheme(event);
  };

  return (
    <button 
      className="theme-toggle" 
      onClick={handleClick}
      aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
    >
      <div className="theme-toggle-slider">
        <span className="theme-toggle-icon sun">☀️</span>
        <span className="theme-toggle-icon moon">🌙</span>
      </div>
    </button>
  );
};

export default ThemeToggle; 